import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Input from "../Components/DynamicComp/Input";
import Button from "../Components/DynamicComp/Button";
import { postData } from "../global/Globalapi";
// import { toast } from "react-toastify";
import swal from "sweetalert";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  // const handleReset = async () => {
  //   if (!password) {
  //     toast.error("Password is required");
  //     return;
  //   }

  //   try {
  //     await postData(`/reset-password/${token}`, {
  //       newPassword: password,
  //     });
  //     toast.success("Password reset successful");
  //     navigate("/");
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Reset failed");
  //   }
  // };

 const handleReset = async () => {
  if (!password) {
 swal("Password is required");
    return;
  }

  try {
    await postData("/reset-password", {
      token,
      newPassword: password,
    });

    swal("Password reset successful");
    navigate("/");
  } catch (error) {
 swal(error?.response?.data?.message || "Reset failed");
  }
};

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border rounded">
      <h2 className="text-xl font-semibold mb-4">Reset Password</h2>

      <Input
        type="password"
        placeholder="New password"
        onChange={(e) => setPassword(e.target.value)}
      />

      <Button className="mt-4 w-full" onClick={handleReset}>
        Reset Password
      </Button>
    </div>
  );
};

export default ResetPassword;
